export interface SelectionBarStateInput {
  selectedCount: number;
  totalRecords: number;
  selectAllMode: boolean;
  selectAllAvailable: boolean;
  rowsSelectionLimit: number;
  showActions: boolean;
}

export type SelectionBarState =
  | { kind: 'hidden' }
  | { kind: 'pageScope'; count: number; total: number; totalKnown: boolean; canEscalate: boolean }
  | { kind: 'allMatching'; total: number; totalKnown: boolean }
  | { kind: 'capReached'; count: number; total: number; totalKnown: boolean; canEscalate: boolean };

export function resolveSelectionBarState(input: SelectionBarStateInput): SelectionBarState {
  const totalKnown = Number.isFinite(input.totalRecords) && input.totalRecords > 0;

  if (!input.showActions || input.selectedCount === 0) {
    return { kind: 'hidden' };
  }

  if (input.selectAllMode) {
    return { kind: 'allMatching', total: input.totalRecords, totalKnown };
  }

  if (input.selectedCount >= input.rowsSelectionLimit) {
    return {
      kind: 'capReached',
      count: input.selectedCount,
      total: input.totalRecords,
      totalKnown,
      canEscalate: input.selectAllAvailable,
    };
  }

  return {
    kind: 'pageScope',
    count: input.selectedCount,
    total: input.totalRecords,
    totalKnown,
    canEscalate: input.selectAllAvailable,
  };
}
